<template lang="pug">
.v-docs.docs(v-if="data" :id="data?.id")
	.docs__tags.tags
		.tags__items(v-if="data.tabs")
			.tags__item(v-for="tab in data.tabs" @click="handlerTabClick(tab)" :class="{'active': tab.active}") {{tab.title}}
	.docs__cards(v-if="data.items")
		a.docs__card(v-for="item in data.items" :href="item.link" :download="item.original")
			.docs__card-title(v-if="item.title") {{item.title}}
			.docs__card-text(v-if="item.text") {{item.text}}
			v-svg-icon.docs__card-icon(icon="graphic-download-red")
	.docs__archive(v-if="data.archiveItems" :class="{'open': showArchive}")
		button.docs__archive-action.btn.btn--stroke(v-if="data.archiveItems.action" type="button" @click="showArchive = !showArchive")
			| {{data.archiveItems.action.text}}
			v-svg-icon.btn__arrow(icon="select-arrow")
		.docs__cards(v-if="data.archiveItems.items && showArchive")
			a.docs__card(v-for="item in data.archiveItems.items" :href="item.link" :download="item.original")
				.docs__card-title(v-if="item.title") {{item.title}}
				.docs__card-text(v-if="item.text") {{item.text}}
				v-svg-icon.docs__card-icon(icon="graphic-download-red")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	props: {
		propsData: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			data: null,
			active: null,
			showArchive: false
		}
	},

	watch: {
		propsData(state) {
			this.data = state;
		}
	},

	mounted() {
		if (this.propsData) {
			this.data = this.propsData;
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.active = data.items?.find(item => item.active);
		},

		requestDataLoad(dataSetOptions) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			this.dataLoad({
				url: this.data.remote,
				delay: false,
				method: 'POST',
				data: {
					id: dataSetOptions.id
				},
			}, dataSetOptions);
		},

		handlerTabClick(item) {
			this.requestDataLoad({id: item.id});
		}
	}
}

</script>